import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetTrackEvent } from "../store/analytics";
import apiService from "../api/api.service";
import moment from "moment";

const ContextCallUpdateAnalytics = () => {
  const dispatch = useDispatch();
  const analytics = useSelector((state) => state.analytics);

  useEffect(() => {
    const interval = setInterval(() => {
      const update = async () => {
        if (analytics.length) {
          await apiService.post("update_analytics", {
            analytics: parseArrAnalytics(analytics),
          });
          dispatch(resetTrackEvent());
        }
      };
      update();
    }, 5000);
    return () => clearInterval(interval);
  }, [analytics]);

  return <div></div>;
};

function parseArrAnalytics(arr) {
  const timeFormat = "YYYY-MM-DD HH:00:00";
  if (!arr.length) return [];
  const output = arr.reduce((prev, curr) => {
    let checkUnique = prev.find((item) => {
      return (
        item[curr.category] !== undefined ||
        moment.unix(item.created_at).format(timeFormat) ===
          moment.unix(curr.created_at).format(timeFormat)
      );
    });
    return checkUnique === undefined
      ? [...prev, { [curr.category]: 1, created_at: curr.created_at }]
      : prev.map((item) => {
          return moment.unix(item.created_at).format(timeFormat) ===
            moment.unix(curr.created_at).format(timeFormat)
            ? {
                ...item,
                [curr.category]: item[curr.category]
                  ? item[curr.category] + 1
                  : 1,
              }
            : item;
        });
  }, []);
  return output.map((item) => JSON.stringify(item));
}

export default ContextCallUpdateAnalytics;
